import { select, arc, pie, interpolate, range } from "d3";

function arcTween(prev, nextArc, innerR, outerR) {
  const arcFn = arc().innerRadius(innerR).outerRadius(outerR);
  const next = nextArc || { startAngle: 0, endAngle: 0 };
  const copy = { ...prev } || { startAngle: 0, endAngle: 0 };
  const interStart = interpolate(copy?.startAngle || 0, next.startAngle);
  const interEnd = interpolate(copy?.endAngle || 0, next.endAngle);
  return function intrpolateAngle(t) {
    const e = 0.0001;
    copy.startAngle = Math.max(e, interStart(t));
    copy.endAngle = Math.min(2 * Math.PI - e, interEnd(t));
    return arcFn(copy);
  };
}

function pieDiagram({ element, margin = 0, duration = 300, arcWidth = 2 }) {
  const svg = select(element);
  const arcDict = {};
  let outerR = 5;
  let innerR = 4;
  let data = [];
  let items = [];

  function calcItems() {
    const ranges = range(items.length);
    const arcs = pie()
      .padAngle(0)
      .sort(null)
      .value((i) => items[i].value)(ranges);

    data = items.map((v, i) => ({ ...v, arc: arcs[i] }));
  }

  function render() {
    const nodes = svg.selectAll("path").data(data, (d) => d.key);

    nodes.exit().remove();

    nodes
      .enter()
      .append("path")
      .attr("fill", (d) => d.color)
      .attr("class", "tw-transform tw-translate-x-1/2 tw-translate-y-1/2")
      .transition()
      .duration(duration)
      .attrTween("d", (d) => arcTween(arcDict[d.key], d.arc, innerR, outerR))
      .on("end", (d) => {
        arcDict[d.key] = d.arc;
      });
  }

  return {
    setDimensions: (width, height) => {
      outerR = (Math.min(width, height) - margin) / 2;
      innerR = outerR - arcWidth;

      svg.attr("height", height);
      svg.attr("width", width);
      svg.attr("viewBox", [0, 0, width, height]);

      calcItems();
      render();
    },

    setData: (dataItems) => {
      items = dataItems;
      calcItems();
      render();
    },
  };
}

export default pieDiagram;
